<template>
  <input
    class="native-input-number"
    type="number"
    :value="modelValue"
    :min="min"
    :max="max"
    :placeholder="placeholder"
    @input="emit('update:modelValue', Number(($event.target as HTMLInputElement).value))"
  />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: number;
    min?: number;
    max?: number;
    placeholder?: string;
  }>(),
  { modelValue: 0 },
);

const emit = defineEmits<{
  (event: "update:modelValue", value: number): void;
}>();
</script>

<style scoped>
.native-input-number {
  min-width: 0;
  padding: 7px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  font: inherit;
}
</style>
